export function isAuditorAssignedSession(session, currentAuditorId, auditorSessionStatuses = {}) {
  if (!session) return false;
  const assignedByRoster = Boolean(
    currentAuditorId && session.auditors?.map(String).includes(String(currentAuditorId))
  );
  const assignedByStatusMap = session.id in auditorSessionStatuses;
  return assignedByRoster || assignedByStatusMap;
}

/** Upcoming tab list + badge — must stay aligned with groupedAuditorUpcoming filter (BUG-mentor-eval-badge-01). */
export function filterAuditorUpcomingSessions(sessions, currentAuditorId, auditorSessionStatuses = {}) {
  return sessions.filter(session =>
    isAuditorAssignedSession(session, currentAuditorId, auditorSessionStatuses)
    && session.status !== 'Completed'
    && session.status !== 'Cancelled'
  );
}

export function filterAuditorPastSessions(sessions, currentAuditorId, auditorSessionStatuses = {}) {
  return sessions.filter(session =>
    isAuditorAssignedSession(session, currentAuditorId, auditorSessionStatuses)
    && session.status === 'Completed'
  );
}